import { useBoolean } from '@dreryk/react-common';
import { ActionBar, PrintIcon } from '@dreryk/react-components';

import { documentTemplateActionTranslationKeys } from '../../../translations';
import { VisitActionBarOrder } from '../VisitActionBar';

import { DocumentTemplateActionBadge } from './DocumentTemplateAction.badge';
import { DocumentTemplateActionModal } from './modal/DocumentTemplateActionModal';

type DocumentTemplateActionProps = {
   readonly visitId: number;
};

export const DocumentTemplateAction = (props: DocumentTemplateActionProps): JSX.Element => {
   const [{ setTrue: openModal, setFalse: closeModal }, modalOpened] = useBoolean(false);

   return (
      <>
         <ActionBar.OptionalLink
            testId={'documentTemplates'}
            icon={
               <DocumentTemplateActionBadge visitId={props.visitId}>
                  <PrintIcon />
               </DocumentTemplateActionBadge>
            }
            name={'documentTemplates'}
            label={documentTemplateActionTranslationKeys.label}
            order={VisitActionBarOrder.DocumentTemplates}
            onClick={openModal}
         />
         {modalOpened ? <DocumentTemplateActionModal onClose={closeModal} visitId={props.visitId} /> : null}
      </>
   );
};
